import type { PermissionSelector } from "@/hooks/usePermission";
import { canListAddresses } from "@/modules/addresses/permissions";
import { canManageCompanies } from "@/modules/companies/permissions";

export const canListUsers: PermissionSelector = (x) => x.userManagement.canListUsers;

export const canInviteUser: PermissionSelector = (x) => x.userManagement.canInviteUser;

export const canBulkUploadUsers: PermissionSelector = (x) => x.userManagement.canBulkUploadUsers;

export const canAddAdmin: PermissionSelector = (x) => x.userManagement.canInviteUser && x.userManagement.canAssignRoles;

// Computed permission for FE to control route access
export const canAccessBulkUploadUsers: PermissionSelector = (x) =>
  canListUsers(x) &&
  canInviteUser(x) &&
  canBulkUploadUsers(x) &&
  ((x.projectType === "addressBased" && canListAddresses(x)) || canManageCompanies(x));
